import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommUnitAllLookup extends Layout {
    sourceMcUnit: DataSource;
    tableMcUnit: Table;
}
